function getDate(date) {
  const dateOptions = {
    day: 'numeric',
    year: 'numeric',
    month: 'short',
  }
  const formattedDate = new Date(date).toLocaleDateString('en-GB', dateOptions)

  return formattedDate || ''
}

const LONG_DATE_OPTIONS = { year: 'numeric', month: 'long', day: 'numeric' }

function formatLongDate(dateString, locale) {
  if (!dateString) return null
  const date = new Date(dateString)
  if (Number.isNaN(date.getTime())) return null
  return date.toLocaleDateString(locale, LONG_DATE_OPTIONS)
}

function timeAgo(timeStamp) {
  const now = new Date()
  try {
    const then = new Date(timeStamp)
    const secondsPast = (now.getTime() - then.getTime()) / 1000

    if (secondsPast < 60) {
      return `${parseInt(secondsPast, 10)} seconds ago`
    }

    if (secondsPast < 3600) {
      return `${parseInt(secondsPast / 60, 10)} minutes ago`
    }

    if (secondsPast <= 86400) {
      return `${parseInt(secondsPast / 3600, 10)} hours ago`
    }

    return then.toISOString().slice(0, 10)
  } catch (error) {
    return ''
  }
}

function getTimeStamp() {
  // get date in format: yyyy-mm-dd hh:mm

  const date = new Date()
  const year = date.getFullYear()
  const month = date.getMonth()
  const day = date.getDate()
  const hours = date.getHours()
  const minutes = date.getMinutes()

  return `${year}-${month}-${day} ${hours}:${minutes}`
}

export { getDate, formatLongDate, timeAgo, getTimeStamp }
